export function computeSpendByModelChartWidthPx(
  containerWidthPx: number,
  taskCount: number,
  minColumnWidthPx: number,
): number {
  if (taskCount <= 0) {
    return containerWidthPx;
  }

  const contentWidth = taskCount * minColumnWidthPx;
  if (containerWidthPx <= 0) {
    return contentWidth;
  }

  return Math.max(containerWidthPx, contentWidth);
}
